import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useResizeDetector } from "react-resize-detector/build/withPolyfill";
import { Annotations } from "~/components/Annotations/Annotations";
export const PDFPageAnnotations = /*#__PURE__*/ memo((param)=>{
    let { canAnnotate, pageNumber, containerRef } = param;
    const { width = 0, height = 0 } = useResizeDetector({
        targetRef: containerRef
    });
    return /*#__PURE__*/ _jsx(Annotations, {
        pageNumber: pageNumber,
        keyShortcutsEnabled: canAnnotate,
        canDrawAnnotation: canAnnotate,
        width: width,
        height: height
    });
});
PDFPageAnnotations.displayName = "PDFPageAnnotations";
